module.exports = __webpack_public_path__ + "static/media/Jalapeno.d85ba9d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/Jalapeno.jpg
// module id = 120
// module chunks = 0